// extracted by mini-css-extract-plugin
export default {"buttonIcon":"buttonIcon_buttonIcon__JRygT"};